"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionCreateSchema = exports.VaultTransactionSchema = exports.DealingCancelSchema = exports.dealingPaymentFields = exports.vaultTxHash = exports.VAULT_TX_HASH_MESSAGE = void 0;
const yup = __importStar(require("yup"));
const mystake_common_sdk_1 = require("@redbelly-tokeniser/mystake-common-sdk");
const UNIT_CLASS_REQUIRED = "Please select a unit class";
const AMOUNT_REQUIRED = "Please enter the amount you want to apply for";
const AMOUNT_INVALID = "Amount must be a positive dollar amount with at most 2 decimal places";
/** Also the API's refusal of a stablecoin cancel sent without its transaction. */
exports.VAULT_TX_HASH_MESSAGE = "Send the transaction hash of the vault transaction";
// A float multiply-and-compare rejects 80000.10, whose product lands a fraction above the whole cent.
const hasCentPrecision = (value) => Math.abs(value * 100 - Math.round(value * 100)) < 1e-6;
/** A vault transaction's hash: an investor's request, cancel or claim, or an operator's decision on the request. */
exports.vaultTxHash = yup
    .string()
    .trim()
    .lowercase()
    .matches(/^0x[0-9a-f]{64}$/, exports.VAULT_TX_HASH_MESSAGE)
    .label("Transaction hash");
/** A stablecoin request names its vault request transaction; the amount comes from that receipt, so any sent is dropped. */
exports.dealingPaymentFields = {
    // No default: an absent value is stored absent and reads as bank.
    paymentMethod: yup.string().oneOf(Object.values(mystake_common_sdk_1.DealingPaymentMethod)).label("Payment method"),
    txHash: yup.string().when("paymentMethod", {
        is: mystake_common_sdk_1.isStablecoinPayment,
        then: () => exports.vaultTxHash.required(exports.VAULT_TX_HASH_MESSAGE),
        otherwise: (schema) => schema.strip(),
    }),
};
/**
 * Cancelling an application or a request. A stablecoin one names its vault cancel transaction, which the API reads;
 * a bank one sends none.
 */
exports.DealingCancelSchema = yup.object({ txHash: exports.vaultTxHash }).noUnknown();
/** A vault transaction the investor sent on an open stablecoin request; the API reads what it did from the receipt. */
exports.VaultTransactionSchema = yup.object({ txHash: exports.vaultTxHash.required(exports.VAULT_TX_HASH_MESSAGE) }).noUnknown();
/** `amountApplied` is dollars; the API converts it to the cents that are stored. */
exports.SubscriptionCreateSchema = yup
    .object({
    unitClassId: yup.string().trim().required(UNIT_CLASS_REQUIRED).label("Unit class"),
    amountApplied: yup
        .number()
        .when("paymentMethod", {
        is: mystake_common_sdk_1.isStablecoinPayment,
        then: (schema) => schema.strip(),
        otherwise: (schema) => schema
            .positive(AMOUNT_INVALID)
            .required(AMOUNT_REQUIRED)
            .test("centPrecision", AMOUNT_INVALID, (value) => value === undefined || hasCentPrecision(value)),
    })
        .label("Amount applied"),
    ...exports.dealingPaymentFields,
})
    .noUnknown();
//# sourceMappingURL=SubscriptionCreateSchema.js.map